import noop from 'utils/noop';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';

export type GroupSelectTriggerProps = {
  /** State to force on checkbox */
  status: CHECKBOX_STATUS;
  /** The click handler for the toggle */
  /** The click handler for the checkbox */
  onCheckboxClick: () => void;
  /** whether or not the button and checkbox are disabled */
  isDisabled?: boolean;
};

export const GroupSelectTrigger = ({
  status = CHECKBOX_STATUS.UNCHECKED,
  onCheckboxClick = noop,
  isDisabled = false,
}) => {
  return (
    <Checkbox
      data-test="group-select-trigger-checkbox"
      tabIndex={-1}
      status={status}
      aria-label="GroupSelectTriggerCheckbox"
      onClick={(e) => {
        // stops the parent div onClick from triggering for checkbox click
        e.stopPropagation();
        onCheckboxClick();
      }}
      isDisabled={isDisabled}
    />
  );
};
